<template>
  <div>
    <check-base-layout
      :pagetitle="pagetitle"
      :check-info-data="checkFrom.purchaseBaseApprovalsVo"
    >
      <template>
        <check-module :title="`合同总览`">
          <compart-module :compart-data="checkFrom.orderContractBaseOtherPayVo"></compart-module>
        </check-module>
        <div v-if="!isReturnPlain">
          <customer-module :customer-data="checkFrom.customerAccountCreditVo"></customer-module>
        </div>
        <div v-else>
          <check-module :title="`退货信息`">
            <template>
              <el-row>
                <el-col class="pb20" :span="8">退货编号：{{orderContractSalereturnGoods.returnNumber}}</el-col>
                <el-col class="pb20" :span="8">售后类型：{{orderContractSalereturnGoods.afterSalesType}}</el-col>
                <el-col class="pb20" :span="8">发起时间：{{orderContractSalereturnGoods.createTime | dateFilter}}</el-col>
              </el-row>
              <el-row>
                <el-col :span="8">公司名称：{{orderContractSalereturnGoods.cusName}}</el-col>
                <el-col :span="8">退货状态：{{orderContractSalereturnGoods.returnState | returnStatus}}</el-col>
                <el-col :span="8">销售总额：{{orderContractSalereturnGoods.salePriceTotal | toFixed}}</el-col>
              </el-row>
            </template>
          </check-module>
        </div>
        <check-module
          :title="`退货方案`"
          :is-table="true"
        >
          <div class="pb20">
            <el-table
              :data="checkFrom.returnGoodsPlainVo"
              border
              :span-method="spanMethod"
              :header-cell-style="tableHeader"
            >
              <el-table-column
                prop="type"
                label="备货方式"
              ></el-table-column>
              <el-table-column
                prop="plain"
                label="退货方案"
              ></el-table-column>
              <el-table-column
                prop="priceTotal"
                label="销售总额"
              >
                <template v-slot="{ row }">{{row.priceTotal | toFixed}}</template>
              </el-table-column>
              <el-table-column
                prop="forfeitureProice"
                label="罚没金额"
              >
                <template v-slot="{ row }">{{row.forfeitureProice | toFixed}}</template>
              </el-table-column>
              <el-table-column
                prop="forfeiturePenalty"
                label="罚没比例"
              >
                <template v-slot="{ row }">{{row.forfeiturePenalty | toPercentFormat}}</template>
              </el-table-column>
            </el-table>
          </div>
          <info-table
            :field-arr="valueFidle"
            :to-fixed-format="['returnGoodsPriiceTotal','forfeitureTotal']"
            :percent-format="['forfeiturePenaltyCount']"
            :table-data="[checkFrom]"
          ></info-table>
        </check-module>
        <check-module :title="`费用结算方案`" v-if="isReturnPlain">
          <template>
            <el-row>
              <el-col class="pb20" :span="8">客户承担：{{orderContractSalereturnGoodsCost.customerCommitment | toFixed}}</el-col>
              <el-col class="pb20" :span="8">公司承担：{{orderContractSalereturnGoodsCost.companyCommitment | toFixed}}</el-col>
              <el-col class="pb20" :span="8">提成结算：{{orderContractSalereturnGoodsCost.commissionSettlement | toFixed}}</el-col>
            </el-row>
            <el-row>
              <el-col :span="8">合同结算：{{orderContractSalereturnGoodsCost.contractSettlement | toFixed}}</el-col>
              <el-col :span="8">费用小计：{{orderContractSalereturnGoodsCost.subtotalExpenses | toFixed}}</el-col>
            </el-row>
          </template>
        </check-module>
        <check-module :title="`退货清单`">
          <template>
            <div>
              <div class="subtitle">
                未备货产品
              </div>
              <info-table
                :field-arr="noStockupField"
                :table-data="checkFrom.orderContractSaleReturnGoodsContentStockupZero"
              ></info-table>
            </div>
            <div>
              <div class="subtitle">
                已发起备货未发起发货产品
              </div>
              <info-table
                :field-arr="yStockupField"
                :table-data="checkFrom.orderContractSaleReturnGoodsContentDeliverStateNotZero"
              ></info-table>
            </div>
            <div>
              <div class="subtitle">
                已发货产品
              </div>
              <info-table
                :field-arr="shipField"
                :table-data="checkFrom.orderContractSaleReturnGoodsContentDeliverStateThree"
              ></info-table>
            </div>
          </template>
        </check-module>
      </template>
      <template v-slot:checkFooter>
        <slot name="footer">
          <check-module :title="`审批信息`">
            <check-info-module :check-data="checkFrom.systemFlowRunAuditOrgVo"></check-info-module>
          </check-module>
        </slot>
      </template>
    </check-base-layout>
    <check-drawer
      :size="`650px`"
      :visible.sync="drawerVisible"
      :row-data.sync="curRow"
    ></check-drawer>
    <check-return-dialog
      :return-dialog.sync="returnDialog"
      :is-stock-up="isStockup"
      :row-data.sync="curRow"
      :row-dataex.sync="curRowex"
    ></check-return-dialog>
  </div>
</template>

<script>
import poMixins from '@/mixin/poMixins'
import CheckDrawer from '@/components/checkLayout/module/checkDrawer'
import checkReturnDialog from '@/components/checkLayout/module/checkReturnDialog'
import checkApi from '@/api/workbench/check'
import { isSuccess } from '@/util/tool'
import { invoiceStateex, stockupTypeStatusex } from '@/meun/date'
import { deepClone } from '@/util'
import * as NP from 'number-precision'

let _that

export default {
  name: 'salesreturnCheck',
  components: {
    CheckDrawer,
    checkReturnDialog
  },
  mixins: [poMixins],
  props: {
    pagetitle: {
      type: String,
      default: '退货审批'
    },
    returnInfo: {},
    isUpdata: {
      type: Boolean,
      default: true
    },
    isReturnPlain: {
      type: Boolean,
      default: false
    }
  },
  data () {
    _that = this
    return {
      drawerVisible: false,
      returnDialog: false,
      isStockup: false,
      tableData: [],
      curRow: {},
      shipField: [
        {
          label: '品牌',
          name: 'brandName'
        },
        {
          label: '型号',
          name: 'proType'
        },
        {
          label: '订货号',
          name: 'orderNumber'
        },
        {
          label: '数量',
          name: 'count'
        },
        {
          label: '产品序列号',
          name: '查看',
          type: 'handler',
          clickNode (item, row) {
            _that.drawerVisible = true
            _that.curRow = deepClone(row)
            _that.curRowex = deepClone(row)
          }
        },
        {
          label: '销售单价',
          name: 'cbPrice'
        },
        {
          label: '开票状态',
          name: 'invoiceState',
          formatter (val) {
            return invoiceStateex[val] || '--'
          }
        },
        {
          label: '退货方案',
          name: 'returnPlain'
        },
        {
          label: '罚没单价',
          name: 'forfeitureProice'
        },
        {
          label: '罚没比例',
          name: 'forfeiturePenalty'
        },
        {
          label: '操作',
          name: '修改退货方案',
          type: 'handler',
          clickNode (item, row) {
            _that.returnDialog = true
            _that.isStockup = true
            _that.curRow = deepClone(row)
            _that.curRowex = deepClone(row)
          }
        }
      ],
      noStockupField: [
        {
          label: '品牌',
          name: 'brandName'
        },
        {
          label: '型号',
          name: 'proType'
        },
        {
          label: '订货号',
          name: 'orderNumber'
        },
        {
          label: '数量',
          name: 'count'
        },
        {
          label: '销售单价',
          name: 'cbPrice'
        },
        {
          label: '开票状态',
          name: 'invoiceState',
          formatter (val) {
            return invoiceStateex[val] || '--'
          }
        },
        {
          label: '退货方案',
          name: 'returnPlain'
        },
        {
          label: '罚没单价',
          name: 'forfeitureProice'
        },
        {
          label: '罚没比例',
          name: 'forfeiturePenalty'
        },
        {
          label: '操作',
          name: '修改退货方案',
          type: 'handler',
          clickNode (item, row) {
            _that.returnDialog = true
            _that.isStockup = false
            _that.curRow = deepClone(row)
            _that.curRowex = deepClone(row)
          }
        }
      ],
      yStockupField: [
        {
          label: '品牌',
          name: 'brandName'
        },
        {
          label: '型号',
          name: 'proType'
        },
        {
          label: '订货号',
          name: 'orderNumber'
        },
        {
          label: '数量',
          name: 'count'
        },
        {
          label: '销售单价',
          name: 'cbPrice'
        },
        {
          label: '备货状态',
          name: 'stockupState',
          formatter (val) {
            return stockupTypeStatusex[val] || '--'
          }
        },
        {
          label: '开票状态',
          name: 'invoiceState',
          formatter (val) {
            return invoiceStateex[val] || '--'
          }
        },
        {
          label: '退货方案',
          name: 'returnPlain'
        },
        {
          label: '罚没单价',
          name: 'forfeitureProice'
        },
        {
          label: '罚没比例',
          name: 'forfeiturePenalty'
        },
        {
          label: '操作',
          name: '修改退货方案',
          type: 'handler',
          clickNode (item, row) {
            _that.returnDialog = true
            _that.isStockup = true
            _that.curRow = deepClone(row)
            _that.curRowex = deepClone(row)
          }
        }
      ],
      valueFidle: [
        {
          label: '退货产品销售总额',
          name: 'returnGoodsPriiceTotal'
        },
        {
          label: '罚没总额',
          name: 'forfeitureTotal'
        },
        {
          label: '罚没比例',
          name: 'forfeiturePenaltyCount'
        }
      ],
      returnPlainField: [
        {
          label: '备货方式',
          name: 'type'
        },
        {
          label: '退货方案',
          name: 'plain'
        },
        {
          label: '销售总额',
          name: 'priceTotal'
        },
        {
          label: '罚没金额',
          name: 'forfeitureProice'
        },
        {
          label: '罚没比例',
          name: 'forfeiturePenalty'
        }
      ],
      curRowex: {},
      loadingtable: false,
      orderContractSalereturnGoods: {},
      orderContractSalereturnGoodsCost: {}
    }
  },
  filters: {
    returnStatus(value) {
      switch (value) {
        case 1:
          return '退货审批'
        case 3:
          return '审批不通过'
        case 4:
        case 5:
        case 6:
        case 7:
        case 8:
        case 9:
        case 10:
          return '退货中'
        case 11:
          return '放弃退货'
        case 12:
          return '退货完成'
        default:
          return '--'
      }
    }
  },
  watch: {
    // 未备货产品
    'checkFrom.orderContractSaleReturnGoodsContentStockupZero': {
      handler (newVal) {
        const {
          returnGoodsPlainVo
        } = this.checkFrom
        const index = returnGoodsPlainVo.findIndex(item => item.type === '未备货产品')
        if (index !== -1) {
          returnGoodsPlainVo[index].priceTotal = 0
          returnGoodsPlainVo[index].forfeitureProice = 0
          returnGoodsPlainVo[index].forfeiturePenalty = 0
          newVal.forEach(item => {
            returnGoodsPlainVo[index].priceTotal += (item.count * item.cbPrice)
            returnGoodsPlainVo[index].forfeitureProice += (item.count * item.forfeitureProice)
          })
          returnGoodsPlainVo[index].forfeiturePenalty += NP.strip(returnGoodsPlainVo[index].forfeitureProice / returnGoodsPlainVo[index].priceTotal)
        }
        this.recalculateTheTotal()
        this.$emit('update:returnInfo', this.checkFrom)
        return newVal
      },
      deep: true
    },
    // 已发起备货未发起发货
    'checkFrom.orderContractSaleReturnGoodsContentDeliverStateNotZero': {
      handler (newVal, oldVal) {
        const {
          returnGoodsPlainVo,
          orderContractSaleReturnGoodsContentDeliverStateThree
        } = this.checkFrom
        returnGoodsPlainVo.forEach((item, i) => {
          if (item.plain === '退至仓库' || item.plain === '退至供应商') {
            returnGoodsPlainVo[i].priceTotal = 0
            returnGoodsPlainVo[i].forfeitureProice = 0
            returnGoodsPlainVo[i].forfeiturePenalty = 0
          }
        })
        const arst = [...orderContractSaleReturnGoodsContentDeliverStateThree, ...newVal]
        const stock = arst.filter(item => item.returnPlain === '退至仓库')
        const supplier = arst.filter(item => item.returnPlain !== '退至仓库')
        let index = returnGoodsPlainVo.findIndex(item => item.type === '已发起备货产品' && item.plain === '退至仓库')
        let index1 = returnGoodsPlainVo.findIndex(item => item.type === '已发起备货产品' && item.plain !== '退至仓库')
        // 退至仓库
        if (index === -1 && stock.length) {
          returnGoodsPlainVo[returnGoodsPlainVo.length] = {
            type: '已发起备货产品',
            plain: '退至仓库',
            priceTotal: 0,
            forfeitureProice: 0,
            forfeiturePenalty: 0
          }
          index = returnGoodsPlainVo.length - 1
        }
        if (index !== -1) {
          stock.forEach(item => {
            returnGoodsPlainVo[index].priceTotal += (item.count * item.cbPrice)
            returnGoodsPlainVo[index].forfeitureProice += (item.count * item.forfeitureProice)
          })
          returnGoodsPlainVo[index].forfeiturePenalty += NP.strip(returnGoodsPlainVo[index].forfeitureProice / returnGoodsPlainVo[index].priceTotal)
        }
        if (index1 === -1 && supplier.length) {
          returnGoodsPlainVo[returnGoodsPlainVo.length] = {
            type: '已发起备货产品',
            plain: '退至供应商',
            priceTotal: 0,
            forfeitureProice: 0,
            forfeiturePenalty: 0
          }
          index1 = returnGoodsPlainVo.length - 1
        }
        if (index1 !== -1) {
          supplier.forEach(item => {
            returnGoodsPlainVo[index1].priceTotal += (item.count * item.cbPrice)
            returnGoodsPlainVo[index1].forfeitureProice += (item.count * item.forfeitureProice)
          })
          returnGoodsPlainVo[index1].forfeiturePenalty += NP.strip(returnGoodsPlainVo[index1].forfeitureProice / returnGoodsPlainVo[index1].priceTotal)
        }
        this.checkFrom.returnGoodsPlainVo = returnGoodsPlainVo
        this.recalculateTheTotal()
        this.$emit('update:returnInfo', this.checkFrom)
        return newVal
      },
      deep: true
    },
    // 已发货产品
    'checkFrom.orderContractSaleReturnGoodsContentDeliverStateThree': {
      handler (newVal, oldVal) {
        const {
          returnGoodsPlainVo,
          orderContractSaleReturnGoodsContentDeliverStateNotZero
        } = this.checkFrom
        returnGoodsPlainVo.forEach((item, i) => {
          if (item.plain === '退至仓库' || item.plain === '退至供应商') {
            returnGoodsPlainVo[i].priceTotal = 0
            returnGoodsPlainVo[i].forfeitureProice = 0
            returnGoodsPlainVo[i].forfeiturePenalty = 0
          }
        })
        const arst = [...orderContractSaleReturnGoodsContentDeliverStateNotZero, ...newVal]
        const stock = arst.filter(item => item.returnPlain === '退至仓库')
        const supplier = arst.filter(item => item.returnPlain !== '退至仓库')
        let index = returnGoodsPlainVo.findIndex(item => item.type === '已发起备货产品' && item.plain === '退至仓库')
        let index1 = returnGoodsPlainVo.findIndex(item => item.type === '已发起备货产品' && item.plain !== '退至仓库')
        // 退至仓库
        if (index === -1 && stock.length) {
          returnGoodsPlainVo[returnGoodsPlainVo.length] = {
            type: '已发起备货产品',
            plain: '退至仓库',
            priceTotal: 0,
            forfeitureProice: 0,
            forfeiturePenalty: 0
          }
          index = returnGoodsPlainVo.length - 1
        }
        if (index !== -1) {
          stock.forEach(item => {
            returnGoodsPlainVo[index].priceTotal += (item.count * item.cbPrice)
            returnGoodsPlainVo[index].forfeitureProice += (item.count * item.forfeitureProice)
          })
          returnGoodsPlainVo[index].forfeiturePenalty += NP.strip(returnGoodsPlainVo[index].forfeitureProice / returnGoodsPlainVo[index].priceTotal)
        }
        if (index1 === -1 && supplier.length) {
          returnGoodsPlainVo[returnGoodsPlainVo.length] = {
            type: '已发起备货产品',
            plain: '退至供应商',
            priceTotal: 0,
            forfeitureProice: 0,
            forfeiturePenalty: 0
          }
          index1 = returnGoodsPlainVo.length - 1
        }
        if (index1 !== -1) {
          supplier.forEach(item => {
            returnGoodsPlainVo[index1].priceTotal += (item.count * item.cbPrice)
            returnGoodsPlainVo[index1].forfeitureProice += (item.count * item.forfeitureProice)
          })
          returnGoodsPlainVo[index1].forfeiturePenalty += NP.strip(returnGoodsPlainVo[index1].forfeitureProice / returnGoodsPlainVo[index1].priceTotal)
        }
        this.checkFrom.returnGoodsPlainVo = returnGoodsPlainVo
        this.recalculateTheTotal()
        this.$emit('update:returnInfo', this.checkFrom)
        return newVal
      },
      deep: true
    },
    curRowex (val, oldval) {
      const { isStockup, checkFrom } = this
      const valex = deepClone(val)
      let {
        orderContractSaleReturnGoodsContentStockupZero,
        orderContractSaleReturnGoodsContentDeliverStateNotZero,
        orderContractSaleReturnGoodsContentDeliverStateThree
      } = checkFrom
      if (!isStockup) {
        orderContractSaleReturnGoodsContentStockupZero = orderContractSaleReturnGoodsContentStockupZero.map(item => {
          if (item.ocsgcId === val.ocsgcId) {
            return Object.assign(item, val)
          }
          return item
        })
      } else if (Array.isArray(val)) {
        const { ocsgcId } = val[0]
        // 已发货备货未发起发货
        if (orderContractSaleReturnGoodsContentDeliverStateNotZero.find(item => item.ocsgcId === ocsgcId)) {
          orderContractSaleReturnGoodsContentDeliverStateNotZero = orderContractSaleReturnGoodsContentDeliverStateNotZero.filter(item => {
            return !(item.ocsgcId === oldval.ocsgcId && item.count === oldval.count && item.forfeitureProice === oldval.forfeitureProice && item.forfeiturePenalty === oldval.forfeiturePenalty && item.returnPlain === oldval.returnPlain)
          })
          orderContractSaleReturnGoodsContentDeliverStateNotZero.forEach(itemex => {
            const obj = val.find(item => {
              return (item.ocsgcId === itemex.ocsgcId && item.forfeitureProice === itemex.forfeitureProice && item.forfeiturePenalty === itemex.forfeiturePenalty && item.returnPlain === itemex.returnPlain)
            })
            // 上次设置的退货方式和本次设置的退货方式 罚没单价一样
            if (obj) {
              itemex.count += obj.count
              val = val.filter(nitem => nitem.returnPlain !== obj.returnPlain)
            }
          })
          this.checkFrom.orderContractSaleReturnGoodsContentDeliverStateNotZero = [...orderContractSaleReturnGoodsContentDeliverStateNotZero, ...val]
        } else {
          debugger
          if (orderContractSaleReturnGoodsContentDeliverStateThree.find(item => item.ocsgcId === ocsgcId)) {
            orderContractSaleReturnGoodsContentDeliverStateThree = orderContractSaleReturnGoodsContentDeliverStateThree.filter(item => {
              return !(item.ocsgcId === oldval.ocsgcId && item.count === oldval.count && item.forfeitureProice === oldval.forfeitureProice && item.forfeiturePenalty === oldval.forfeiturePenalty && item.returnPlain === oldval.returnPlain)
            })
            orderContractSaleReturnGoodsContentDeliverStateThree.forEach(itemex => {
              const obj = val.find(item => {
                return (item.ocsgcId === itemex.ocsgcId && item.forfeitureProice === itemex.forfeitureProice && item.forfeiturePenalty === itemex.forfeiturePenalty && item.returnPlain === itemex.returnPlain)
              })
              // 上次设置的退货方式和本次设置的退货方式 罚没单价一样
              if (obj) {
                itemex.count += obj.count
                val = val.filter(nitem => nitem.returnPlain !== obj.returnPlain)
              }
            })
            this.checkFrom.orderContractSaleReturnGoodsContentDeliverStateThree = [...orderContractSaleReturnGoodsContentDeliverStateThree, ...val]
          }
        }
      }
      return Array.isArray(valex) ? valex[0] : valex
    }
  },
  created () {
    const { snaId, isUpdata, isReturnPlain } = this
    if (!isUpdata) {
      this.shipField.splice(-1)
      this.noStockupField.splice(-1)
      this.yStockupField.splice(-1)
    }
    if (!isReturnPlain) {
      checkApi.getSalesreturnCheckInfo({ snaId }).then(res => {
        if (isSuccess(res)) {
          this.checkFrom = res.data.obj || {}
          this.$emit('update:data', res.data.obj)
        }
      })
    } else {
      checkApi.getSalesCheckInfo({
        snaId
      }).then(res => {
        if (isSuccess(res)) {
          this.checkFrom = res.data.obj || {}
          const { customerAccountCreditVo } = this.checkFrom
          this.orderContractSalereturnGoods = this.checkFrom.orderContractSalereturnGoods || {}
          Object.assign(this.orderContractSalereturnGoods, {
            cusName: this.checkFrom.customerAccountCreditVo?.cusName ?? ''
          })
          Object.assign(this.checkFrom.orderContractBase || {}, {
            ownName: this.checkFrom.ownName,
            cusName: customerAccountCreditVo && customerAccountCreditVo.cusName
          })
          this.orderContractSalereturnGoodsCost = this.checkFrom.orderContractSalereturnGoodsCost || {}
          this.$emit('update:data', res.data.obj)
        }
      })
    }
  },
  methods: {
    // 设置头部背景色
    tableHeader ({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    },
    recalculateTheTotal() {
      let {
        returnGoodsPlainVo
      } = this.checkFrom
      let priceTotal = 0 // 销售总额
      let forfeitureProice = 0 // 罚没总额
      let forfeiturePenalty = 0 // 罚没比例
      returnGoodsPlainVo = returnGoodsPlainVo.filter(item => {
        return item.priceTotal || item.forfeitureProice || item.forfeiturePenalty
      })
      returnGoodsPlainVo.forEach(item => {
        priceTotal += item.priceTotal
        forfeitureProice += item.forfeitureProice
      })
      forfeiturePenalty = NP.strip(forfeitureProice / priceTotal)
      Object.assign(this.checkFrom, {
        returnGoodsPriiceTotal: priceTotal,
        forfeitureTotal: forfeitureProice,
        forfeiturePenaltyCount: forfeiturePenalty
      })
      this.checkFrom.returnGoodsPlainVo = returnGoodsPlainVo
    },
    spanMethod ({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        if (rowIndex === 1) {
          return {
            rowspan: 2,
            colspan: 1
          }
        } else if (rowIndex === 2) {
          return {
            rowspan: 0,
            colspan: 0
          }
        } else {
          return {
            rowspan: 1,
            colspan: 1
          }
        }
      }
    }
  }
}
</script>

<style scoped>
  .subtitle {
    padding: 15px 0px;
    font-size: 16px;
    font-weight: 500;
  }
</style>
